import axios from '~/utils/axiosInstance';

const baseUrl = '/marketplace';

export interface CreateMarketplaceListingRequest {
    projectId?: string;
    portfolioId?: string;
    description?: string;
    isVisible?: boolean;
    badgeIds?: number[];
}

export interface UpdateMarketplaceListingRequest {
    projectId?: string;
    portfolioId?: string;
    description?: string;
    isVisible?: boolean;
    badgeIds?: number[];
}

export interface ToggleInterestRequest {
    isInterested?: boolean;
}

export interface ListMarketplaceListingsResponse {
    listings: unknown[];
    listingsRestricted: boolean;
}

export const listMarketplaceListings = async function (): Promise<ListMarketplaceListingsResponse> {
    const response = await axios.get(baseUrl);
    const data = response.data;
    if (Array.isArray(data)) {
        return { listings: data, listingsRestricted: false };
    }
    return {
        listings: data?.listings ?? [],
        listingsRestricted: Boolean(data?.listingsRestricted),
    };
};

export const getMarketplaceListingById = async function (params: { projectId?: string; portfolioId?: string }) {
    const response = await axios.get(`${baseUrl}/findById`, { params });
    return response.data;
};

export const createMarketplaceListing = async function (request: CreateMarketplaceListingRequest) {
    const response = await axios.post(baseUrl, request);
    return response.data;
};

export const updateMarketplaceListing = async function (marketplaceListingId: string, updateData: UpdateMarketplaceListingRequest) {
    const response = await axios.patch(baseUrl + '/' + marketplaceListingId, updateData);
    return response.data;
};

export const toggleMarketplaceInterest = async function (marketplaceListingId: string, interestData: ToggleInterestRequest = { isInterested: true }) {
    const response = await axios.post(baseUrl + '/' + marketplaceListingId + '/interest', interestData);
    return response.data;
};

export const getMarketplaceBadges = async function () {
    const response = await axios.get(`${baseUrl}/badges`);
    return response.data;
};